import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import MyStorage from '../../common/MyStorage';
import { userLogout } from "../../redux/actions/postActions";
import { KMTracking } from '../Tracking/KMTracking';
import { Link } from 'react-router-dom';    

const SideMenu = (props) => {
    const [givenName, setGivenName] = useState('');
    const [path, setPath] = useState('')

    useEffect(() => {
        const storage = new MyStorage();
        const token = storage.getloggedIn()
        const pathName = props?.props?.location?.pathname ? props?.props?.location?.pathname : ""
        if (pathName !== "") {
            setPath(pathName)
        }
        if (token == "true") {
            const given_name = storage.getName()?.split(' ')[0];
            setGivenName(given_name ? given_name : '')
        } else {
            props?.props?.history?.push('/login')
        }
    }, [path])
    const tracker = async (eventName, _kmprops) => {
        await KMTracking(eventName, _kmprops)
    }
    return (
        <div className="left-panel">

            {/* greeting */}
            <div className="greeting">
                Hello, {givenName}
            </div>
            {/* /greeting */}

            {/* links */}
            <div className="links">
                <ul>
                    <li className={(path?.includes("my") || path?.includes("detail") || path?.includes("returns")) ? "active" : ""}><Link to={'/my-orders'}
                    >My Orders</Link>
                        <ul>
                            <li className={path?.includes("order-detail") ? "active" : ""}><Link to={'/my-orders'}>Orders</Link></li>
                            <li className={path?.includes("refund-details") ? "active" : ""}><Link to={`/my-orders/${"refunds"}`}>Returns</Link></li>
                        </ul>
                    </li>
                    <li className={(path?.includes("address") || path?.includes("add-address")) ? "active" : ""}><Link to={{pathname:'/address-book',state:{from: 'Side Menu'} }}>Address Book</Link></li>
                    <li className={path?.includes("payment") ? "active" : ""}><Link to={{pathname:'/payment-methods',state:{ from: 'Side Menu' }}}>Payment Methods</Link></li>
                    <li><a
                    target="_blank"
                    href="https://www.frasersexperience.com/fr-page.php?CategoryID=744"
                     onClick={() => {
                        let eventData = {
                            'location type': 'side Menu'
                        }
                        tracker('Opened Order Help and FAQ Screen', eventData)

                    }}>Order Help & FAQ</a></li>
                    <li className={path?.includes("profile") ? "active" : ""}><Link to={'/profile'}>Profile</Link></li>
                    <li><a onClick={() => {
                        new MyStorage().clearStorage()
                        props.userLogout();
                        localStorage.clear()
                        props?.props?.history?.push("/")
                    }}>Log Out</a></li>
                </ul>
            </div>
            {/* /links */}

        </div>
    )
}
const mapStateToProps = (state) => {
    const { cart_count } = state.UserReducer
    return { cart_count }
};
const actions = {
    userLogout,
};
export default connect(mapStateToProps, actions)(SideMenu);